<template>
  <div class="betascore-widget">
    <div class="score-container">
      <CalicoTier :tier="tierName" />

      <CalicoTierChip
        :tier-class="tierColorClass"
        :risk-level="riskLevel"
        :data-confidence="dataConfidence"
        :score="score"
      />

      <div class="learn-links">
        <div class="learn-link--understand">
          <button
            class="button-tertiary--small"
            @click="showUnderstand = true"
          >
            Understand the BetaScore
            <i class="bi bi-question-circle" />
          </button>
        </div>

        <div class="learn-link--tiers">
          <button
            class="button-tertiary--small"
            @click="showTiers = true"
          >
            View Tiers Table
            <i class="bi bi-question-circle" />
          </button>
        </div>
      </div>
    </div>

    <UnderstandBetascoreDialog
      v-if="showUnderstand"
      @close="showUnderstand = false"
    />
    <TiersTableDialog
      v-if="showTiers"
      @close="showTiers = false"
    />
  </div>
</template>

<script>
import CalicoTier from '@/components/calico/tier/index.vue'
import CalicoTierChip from '@/components/calico/tierChip/index.vue'
import UnderstandBetascoreDialog from '@/components/pattern/understandBetascoreDialog/index.vue'
import TiersTableDialog from '@/components/pattern/tiersTableDialog/index.vue'
import { resolveTierName, getTierColorClass, resolveRiskLevel } from '@/utils/score'
import { DataConfidence } from '@/enums'

export default {
  name: 'BetascoreWidget',
  components: {
    CalicoTier,
    CalicoTierChip,
    UnderstandBetascoreDialog,
    TiersTableDialog
  },
  props: {
    score: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      showUnderstand: false,
      showTiers: false
    }
  },
  computed: {
    tierName() {
      return resolveTierName(this.score)
    },
    tierColorClass() {
      return getTierColorClass(this.tierName)
    },
    riskLevel() {
      return resolveRiskLevel(this.score)
    },
    dataConfidence() {
      const s = this.score || {}
      return (
        s.dataConfidence ||
        s.betaScoreConfidence ||
        s.confidence ||
        (s.betaScoreOutput && s.betaScoreOutput.betaScoreConfidence) ||
        DataConfidence.UNAVAILABLE
      )
    }
  }
}
</script>

<style scoped lang="scss">
.betascore-widget {
  @include inset-space($space-large);
  @include inline-space($space-large);
  background: $color-black;
  color: $color-white;
 
  .score-container {
    @include stack-space($space-medium);
    align-items: center;
    width: 100%;
    text-align: center;
    padding: $space-xlarge;
    gap: $space-large;
  }

  .learn-links {
    @include inline-space($space-medium);
    align-items: center;
    justify-content: center;
    gap: $space-large;
    width: 309px;
    height: 18px;
    margin-top: $space-small;

    .button-tertiary--small {
      color: $color-white;
      white-space: nowrap;
    }

    .learn-link--understand,
    .learn-link--tiers {
      width: fit-content; 
    }
  }
}
</style>
